import { reactive } from 'vue'

/**
 * Global application state.
 *
 * Replaces the former `Vue.prototype.$user/$token/$fxs/$ds/$apiKeys` pattern,
 * which is not available in Vue 3. This is a single reactive singleton that can
 * be imported directly from plain JS (e.g. src/plugins/adp.js) and is also
 * exposed on the component instance as `this.$user`, `this.$token`, etc. via
 * `installGlobals()` below.
 */
export const globals = reactive({
  user: undefined,
  token: undefined,
  fxs: [],
  ds: null,
  apiKeys: null,
})

const KEYS = ['user', 'token', 'fxs', 'ds', 'apiKeys']

/**
 * Exposes the reactive globals on `app.config.globalProperties` so that existing
 * components can keep using `this.$user`, `this.$token`, `this.$fxs`, `this.$ds`
 * and `this.$apiKeys` unchanged.
 */
export function installGlobals(app) {
  for (const k of KEYS) {
    Object.defineProperty(app.config.globalProperties, '$' + k, {
      get() {
        return globals[k]
      },
      set(v) {
        globals[k] = v
      },
    })
  }
}
